import axios from "axios";
import url, { baseUrl, cdnUrl } from "../utils/url";
import getError from "../utils/getError";

export const adminSendOtp = (data, afterAsync) => {
  axios
    .post(url + `/auth`, data)
    .then((res) => {
      afterAsync(true);
    })
    .catch((err) => {
      afterAsync(false);
    });
};

export const getCustomers = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/customers` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getComplains = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/complains` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCustomerBadgeStats = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/badge/stats` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateShippingCharge = (data, afterPerform) => {
  axios
    .put(url + `/order/shippingcharge/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateShippingChargeV4 = (data, afterPerform) => {
  axios
    .put(url + `/purchase/v4/shipping-charge/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getCustomerOderReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/customer/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getAllInvoices = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/deliveries` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPurchasingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getNonVerifiedPurchaseList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v3/orders/non-verified` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getNonApprovedOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/non-approved` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getVerifiedPurchaseList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v3/orders/verified` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchasingV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/purchasing` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getManualPurchaseV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/manual` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getRepurchaseV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/repurchase` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchaseCompletedV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/purchase-completed` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchaseCenterV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/all` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getConfirmationCenterV4 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v4/orders/need-confirmation` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getManualPurchaseList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v3/orders/manual` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getReadySheets = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v3/group-sheets` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getReadySheetsDownload = (setData, data) => {
  axios
    .post(url + `/purchase/v3/generate-sheet`, data)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(false, getError(err));
    });
};

export const verifyNonVerifiedPurchase = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/v3/approve/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      console.log(err);
      afterAsync(false, getError(err));
    });
};
export const verifyNonVerifiedPurchaseV4 = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/v4/approve/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      console.log(err);
      afterAsync(false, getError(err));
    });
};

export const rejectNonVerifiedPurchaseV4 = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/v4/deny/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const rejectNonVerifiedPurchase = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/v3/deny/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const getDisasterOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/disaster/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSeaPendingOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sea/orders/pending` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getDelivery = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/delivery/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDeliveries = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/deliveries` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getReturnDeliveries = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/delivery/invoice/skybuy/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateReturnSteadfast = (id, path, data, afterAsync) => {
  axios
    .put(baseUrl + `/delivery/courier/return/${path}/${id}`, data)
    .then((res) => {
      afterAsync(true);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const getSteadFastBooking = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/courier/steadfast/bookings` + filters)
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getSkyExpressBooking = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/courier/skyexpress/bookings` + filters)
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const initiateDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/initiate`, filter)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const initiatePurchase = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/initiate/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const updatePurchaseStepOneV4 = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/v4/update/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const needCustomerConfirmationV4 = (id, data, afterAsync) => {
  axios
    .post(url + `/purchase/v4/need-confirmation/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const submitCustomerConfirmationV4 = (id, data, afterAsync) => {
  axios
    .post(url + `/purchase/v4/submit-confirmation/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const confirmPurchase = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/supplier-confirm/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const getOrderCartons = (id, afterAsync) => {
  axios
    .get(url + `/shipment/cartons/${id}`)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const placeCourierBooking = (data, afterAsync) => {
  axios
    .post(url + `/courier`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const executeDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/execute`, filter)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const getTrackingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tracking/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdmins = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/admins` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCrmManagers = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/crm/managers` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getEmployees = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/employees` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCrmManagerTargets = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/crm/manager/targets` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSlabDisabledCustomer = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/slab/customers/disabled` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateSlabControl = (id, data, afterPerform) => {
  axios
    .put(url + `/slab/customer/manage/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const warehouseTransferBulk = (data, afterPerform) => {
  axios
    .put(url + `/delivery/bulk/stage`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getAgents = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/agents` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/statuses` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/order/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBankReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/bank/daily` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getInvestmentReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/investment/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSteadFastReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/steadfast/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getRefundReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/refund/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrderProfitReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/profit/order` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getDeliveryPaymentReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/delivery/daily` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDeliveryDueReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/officedelivery/due` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getRefundableList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/refund/pending` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getRefundReadyList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/refund/ready` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const readyRefund = (id, data, afterPerform) => {
  axios
    .put(url + `/refund/ready/${id}`, data)
    .then((res) => {
      afterPerform(id);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const completeRefund = (id, data, afterPerform) => {
  axios
    .put(url + `/refund/complete/${id}`, data)
    .then((res) => {
      afterPerform(id);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getPaymentReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/segment/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getGatewayReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/gateway/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchaseReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/purchase/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getEmployeePurchaseReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/purchased/employee` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShipmentInvoiceReport = (setData, id) => {
  axios
    .get(url + `/report/shipment/invoice/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getEmployeePurchasingReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/purchasing/employee` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCashReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/cash/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCallReportMonthly = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/call/count/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSmsReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sms/gateways/info` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCoupons = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/coupons` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCampaigns = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/campaigns` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getGalleries = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/galleries` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getGalleryCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/gallery/categories` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShipmentStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/statuses` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPayable = (setData, filter) => {
  axios
    .post(url + `/payment/payable`, filter)
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const autoTrackingComplete = (data, afterAsync) => {
  axios
    .post(url + `/tracking/auto/complete`, data)
    .then((res) => {
      afterAsync(res.data);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const autoPaymentComplete = (data, afterAsync) => {
  axios
    .post(url + `/purchase/payment/auto`, data)
    .then((res) => {
      afterAsync(res.data);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const autoSupplierConfirmation = (data, afterAsync) => {
  axios
    .post(url + `/purchase/supplier-confirmation/auto`, data)
    .then((res) => {
      afterAsync(res.data);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const autoPurchaseComplete = (data, afterAsync) => {
  axios
    .post(url + `/purchase/auto/complete`, data)
    .then((res) => {
      afterAsync(res.data);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};
export const autoPurchaseVerification = (data, afterAsync) => {
  axios
    .post(url + `/purchase/verification/auto`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};
export const autoDetectPurchase = (data, afterAsync) => {
  axios
    .post(url + `/purchase/v3/detect-purchase`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const bulkVerifySendForPayment = (data, afterAsync) => {
  axios
    .post(url + `/purchase/verification/bulk`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const sendForManualPurchase = (data, afterAsync) => {
  axios
    .post(url + `/purchase/v3/manual-purchase`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const bulkPurchaseComplete = (data, afterAsync) => {
  axios
    .post(url + `/purchase/complete/bulk`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const updatePurchase = (id, data, afterAsync) => {
  axios
    .put(url + `/purchase/update/${id}`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const getProfile = (setData) => {
  axios
    .get(url + `/profile`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getMasterInvoice = (id, setData) => {
  axios
    .get(url + `/delivery/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateProfile = (data, afterPerform) => {
  axios
    .put(url + `/profile`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const reviewPayment = (id, data, afterPerform) => {
  axios
    .put(url + `/payment/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const forceReceive = (id, afterPerform) => {
  axios
    .put(url + `/order/receive/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const approveRisky = (id, data, afterPerform) => {
  axios
    .put(url + `/order/risky/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateTracking = (id, data, afterPerform) => {
  axios
    .put(url + `/order/tracking/${id}`, data)
    .then((res) => {
      afterPerform(id);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateShipment = (id, data, afterPerform) => {
  axios
    .put(url + `/shipment/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const deleteTracking = (orderId, trackingId, afterPerform) => {
  axios
    .delete(url + `/order/tracking/${orderId}/${trackingId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateOrderItem = (orderId, itemId, data, afterPerform) => {
  axios
    .put(url + `/order/item/${orderId}/${itemId}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const cancelDelivery = (id, afterPerform) => {
  axios
    .delete(url + `/delivery/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const cancelBooking = (id, afterPerform) => {
  axios
    .put(url + `/courier/cancel/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeDelivery = (id, afterPerform) => {
  axios
    .put(url + `/delivery/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getPaymentTransactions = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/payments` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBalanceTransactions = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/balance/logs` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getRefundHistory = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/refund/history` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShipments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipments` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipment = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/${id}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getMetas = (type, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/metas${type ? "/" + type : ""}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const updateMeta = (id, data, afterPerform) => {
  axios
    .put(url + `/meta/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const getSortingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sorting/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCustomerQc = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/qc/response/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShippingCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/categories` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShippingChargeCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipping/charge/categories` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addShippingChargeCategory = (data, afterPerform) => {
  axios
    .post(url + `/shipping/charge/category`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateShippingChargeCategory = (id, data, afterPerform) => {
  axios
    .put(url + `/shipping/charge/category/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const getShippingCharges = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/charges` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const resolveQcComplain = (code, data, afterPerform) => {
  axios
    .post(url + `/qc/response/${code}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false);
    });
};
export const resolveComplain = (code, data, afterPerform) => {
  axios
    .put(url + `/complain/${code}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false);
    });
};

export const getQcAcknowledgeOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/qc/acknowledge/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const acknowledgeQc = (id, afterPerform) => {
  axios
    .put(url + `/qc/acknowledge/order/${id}`)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderPurchaseRate = (id, data, afterPerform) => {
  axios
    .put(url + `/order/purchase/note/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const replaceTracking = (id, data, afterPerform) => {
  axios
    .put(url + `/order/tracking-replace/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const addChinaNote = (type, id, data, afterPerform) => {
  let mUrl = type === "order" ? "/order/china-note" : "/ticket/china-note";
  axios
    .put(url + `${mUrl}/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderPurchaseInfo = (id, data, afterPerform) => {
  axios
    .put(url + `/order/purchase/info/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const changePurchaseStage = (stage, id, data, afterPerform) => {
  axios
    .put(url + `/purchase/manage/${stage}/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getIncompletePurchase = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list/incomplete` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCustomerConfirmationList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/orders/waiting` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchaseVerification = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list/verification` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getForLogisticConfirmation = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/orders/purchasing` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPreVerifiedPurchaseOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/orders/pre-verified` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getWaitingPurchaseOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/v3/orders/pending` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getVerifiedPurchaseOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/orders/verified` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchasePayment = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list/payment` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCallReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/call/stats/daily` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdminCalls = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/calls` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCampaign = (setData, id) => {
  axios
    .get(url + `/campaign/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getTicket = (setData, id) => {
  axios
    .get(url + `/ticket/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCampaignCustomers = (campaign_id, type, segment, setData) => {
  axios
    .get(url + `/campaign/customers/${campaign_id}/${type}?segment=${segment}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const uploadFile = (data, url, afterPerform) => {
  axios
    .post(cdnUrl + url, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getTickets = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tickets` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {});
};
export const getChats = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/chats` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAgentOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/agentorders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getAgentWithdraws = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/agentwithdraws` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPurchaseCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/categories` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getChecks = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/checks` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAgentWithdraw = (id, setData) => {
  axios
    .get(url + `/agentwithdraw/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrder = (setData, id) => {
  axios
    .get(url + `/order/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getGallery = (setData, id) => {
  axios
    .get(url + `/gallery/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrderActivityLogs = (setData, id) => {
  axios
    .get(url + `/order/activities/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSingleCategory = (setData, id) => {
  axios
    .get(url + `/category/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrderPurchaseList = (setData, id) => {
  axios
    .get(url + `/order/purchase/info/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCustomer = (setData, id) => {
  axios
    .get(url + `/customer/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdmin = (setData, id) => {
  axios
    .get(url + `/admin/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateCustomer = (id, data, afterPerform) => {
  axios
    .put(url + `/customer/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const verifyPurchaseOrder = (id, data, afterPerform) => {
  axios
    .put(url + `/order/purchase/verify/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const confirmLogisticPurchaseInfo = (id, data, afterPerform) => {
  axios
    .put(url + `/purchase/logistic-confirm/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addAdmin = (data, afterPerform) => {
  axios
    .post(url + `/admin`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const assignDeliveryToCrm = (id, data, afterPerform) => {
  axios
    .put(url + `/crm/assign/delivery/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const assignPurchaseToCrm = (id, data, afterPerform) => {
  axios
    .put(url + `/crm/assign/purchase/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addShippingCharge = (data, afterPerform) => {
  axios
    .post(url + `/charge`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const assignCrmTarget = (data, afterPerform) => {
  axios
    .post(url + `/crm/manager/target`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getCustomerReport = (setData, filter, type) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/advanced/customers/${type}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPointCustomers = (setData, filter, type) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/advanced/customers/balance` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const assignCrmManager = (data, afterPerform) => {
  axios
    .post(url + `/crm/manager/assign`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addAgent = (data, afterPerform) => {
  axios
    .post(url + `/agent`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addTicket = (data, afterPerform) => {
  axios
    .post(url + `/ticket`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateTicket = (id, data, afterPerform) => {
  axios
    .put(url + `/ticket/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateShippingChargeSea = (id, data, afterPerform) => {
  axios
    .put(url + `/charge/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateAgent = (id, data, afterPerform) => {
  axios
    .put(url + `/agent/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addTicketMessage = (data, afterPerform) => {
  axios
    .post(url + `/chat`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const bulkUpdateCategoryCharge = (data, afterPerform) => {
  axios
    .post(url + `/charge/add`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const bulkRemoveCategoryCharge = (data, afterPerform) => {
  axios
    .post(url + `/charge/remove`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const initiateCashPayment = (data, afterPerform) => {
  axios
    .post(url + `/payment/initiate/cash`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const checkRefundAdjustable = (data, afterPerform) => {
  axios
    .post(url + `/refund/check-adjustable`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const adjustRefundableOrders = (data, afterPerform) => {
  axios
    .post(url + `/refund/adjust`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addCoupon = (data, afterPerform) => {
  axios
    .post(url + `/coupon`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const addCampaign = (data, afterPerform) => {
  axios
    .post(url + `/campaign`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addGallery = (data, afterPerform) => {
  axios
    .post(url + `/gallery`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeSorting = (id, data, afterPerform) => {
  axios
    .put(url + `/order/sorting/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const reviewAgentWithdrawal = (id, data, afterPerform) => {
  axios
    .put(url + `/agentorder/review/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const removeLogistic = (orderId, logisticId, afterPerform) => {
  axios
    .delete(url + `/order/sorting/${orderId}/${logisticId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createShipment = (data, afterPerform) => {
  axios
    .post(url + `/shipment`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addOrderNote = (data, afterPerform) => {
  axios
    .put(url + `/order/note/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addRmbTransaction = (data, afterPerform) => {
  axios
    .post(url + `/rmb/transaction`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addTicketNote = (ticket_id, data, afterPerform) => {
  axios
    .put(url + `/ticket/note/${ticket_id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addOrderDiscount = (id, data, afterPerform) => {
  axios
    .put(url + `/order/discount/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addAdminCall = (data, afterPerform) => {
  axios
    .post(url + `/call`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteBD = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/bd/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteCN = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/cn/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderStatus = (data, afterPerform) => {
  axios
    .put(url + `/order/status/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCategory = (data, afterPerform) => {
  axios
    .put(url + `/category/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderShippingMethod = (data, afterPerform) => {
  axios
    .put(url + `/order/shippingmethod/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updatePayablePercentage = (data, afterPerform) => {
  axios
    .put(url + `/order/payable/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateAdmin = (id, data, afterPerform) => {
  axios
    .put(url + `/admin/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCrmTarget = (id, data, afterPerform) => {
  axios
    .put(url + `/crm/manager/target/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCoupon = (id, data, afterPerform) => {
  axios
    .put(url + `/coupon/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCampaign = (id, data, afterPerform) => {
  axios
    .put(url + `/campaign/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateGallery = (id, data, afterPerform) => {
  axios
    .put(url + `/gallery/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const uploadGallery = (id, type, data, afterPerform) => {
  axios
    .put(url + `/gallery/${id}/${type}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const deleteGalleryItem = (id, fileID, afterPerform) => {
  axios
    .delete(url + `/gallery/${id}/${fileID}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getReport = (setData, type) => {
  axios
    .get(url + `/report/summary/${type}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderStats = (setData) => {
  axios
    .get(url + `/report/orderstatus/stats`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const sendBulkNotification = (data, afterPerform) => {
  axios
    .post(url + `/marketing/bulk-notification`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getTasks = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tasks` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addTask = (data, afterAsync) => {
  axios
    .post(url + `/task`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const getTask = (id, setData) => {
  axios
    .get(url + `/task/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateTask = (id, data, afterPerform) => {
  axios
    .put(url + `/task/${id}`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateTaskStatus = (id, data, afterPerform) => {
  axios
    .put(url + `/task/status/${id}`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const initiateAdminChatroom = (data, afterAsync) => {
  axios
    .post(url + `/admin-chatroom/initiate`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

// B2C Recharge APIs
export const getB2CRechargeHistory = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/b2c/history` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addB2CRecharge = (data, afterPerform) => {
  axios
    .post(url + `/b2c/recharge`, data)
    .then((res) => {
      afterPerform(res.data?.result);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const getB2CBalance = (setData) => {
  axios
    .get(url + `/b2c/balance`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
